import { TRACK_EVENT_NAMES } from 'Tracking/constants';

const CLUB_MED_LAYER = 'clubMedLayer';

export function reset() {
  delete global.window[CLUB_MED_LAYER];
}

export function set(data, referrerKey = 'referrer') {
  if (global.window) {
    if (!global.window[CLUB_MED_LAYER]) {
      global.window[CLUB_MED_LAYER] = [];
    }
    if (data) {
      const payload =
        data.event === TRACK_EVENT_NAMES.PAGE_VIEW
          ? { [referrerKey]: document.referrer, ...data }
          : data;
      global.window[CLUB_MED_LAYER].push(payload);
    }
  }
}

export function getDataLayer() {
  return global.window[CLUB_MED_LAYER] || [];
}
